import { PRODUCTS } from '@boltenergy-be/shared'
import { Month, RegistrationSteps } from './types'

export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_FORMAT_ISO = 'YYYY-MM-DD'

export const DAYS_TO_YEARS_COEFFICIENT = 0.002738

export const REGISTRATION_FLOW = [
  RegistrationSteps.DELIVERY_ADDRESS,
  RegistrationSteps.PERSONAL_DATA,
  RegistrationSteps.METER_DETAILS,
  RegistrationSteps.BILLING,
  RegistrationSteps.OVERVIEW,
  RegistrationSteps.CONFIRMATION
]

export const MIN_AGE = 18

export const MONTHS: Month[] = [
  {
    i18nKey: 'january'
  },
  {
    i18nKey: 'february'
  },
  {
    i18nKey: 'march'
  },
  {
    i18nKey: 'april'
  },
  {
    i18nKey: 'may'
  },
  {
    i18nKey: 'june'
  },
  {
    i18nKey: 'july'
  },
  {
    i18nKey: 'august'
  },
  {
    i18nKey: 'september'
  },
  {
    i18nKey: 'october'
  },
  {
    i18nKey: 'november'
  },
  {
    i18nKey: 'december'
  }
]

export const PREFERRED_PHONE_COUNTRIES = ['be', 'nl', 'fr', 'de', 'lu']

export const PROPOSITIONS_ORDER = [PRODUCTS.fix, PRODUCTS.variableOffline, PRODUCTS.variableOnline]
